import { createContext, ReactNode, useEffect, useState } from "react"
import { Image } from "../shared/models/Image"
import { Months } from "../shared/types/Months"

export type Orientations = 'horizontal' | 'vertical'

type DataContextType = {
  orientation: Orientations
  images: Image[]
  selectedImages: {
    [key in Months]: Image | undefined
  },
  selectImage: (image: Image, month: Months) => void
  changeOrientation: (orientation: Orientations) => void,
  print: () => void
}

const DEFAULT_STATE: DataContextType = {
  orientation: 'vertical',
  images: [],
  selectedImages: {
    january: undefined,
    february: undefined,
    march: undefined,
    april: undefined,
    may: undefined,
    june: undefined,
    july: undefined,
    august: undefined,
    september: undefined,
    october: undefined,
    november: undefined,
    december: undefined,
  },
  selectImage: (image: Image, month: Months) => {},
  changeOrientation: (orientation: Orientations) => {},
  print: () => {}
}

export const DataContext = createContext<DataContextType>(DEFAULT_STATE)

type ProviderProps = {
  children: ReactNode
}

export function DataContextProvider(props: ProviderProps) {
  const [state, setState] = useState({
    orientation: DEFAULT_STATE.orientation,
    images: DEFAULT_STATE.images,
    selectedImages: DEFAULT_STATE.selectedImages
  })

  const dataTagId = 'calendar-data'

  const handleStateChange = (newState: object) => {
    setState(state => ({ ...state, ...newState }))
  }

  const changeOrientation = (orientation: Orientations) => {
    handleStateChange({ orientation })
  }

  const handleImageSelection = (image: Image, month: Months) => {
    const selectedImages = { ...state.selectedImages, [month]: image }
    handleStateChange({ selectedImages })
  }

  const handlePrint = () => {
    window.print()
  }

  useEffect(() => {
    const data = document.getElementById(dataTagId)
    const parsedJson = JSON.parse(data?.innerText as string)

    handleStateChange({ images: parsedJson })
  }, [])

  return (
    <DataContext.Provider value={{
      images: state.images,
      selectedImages: state.selectedImages,
      selectImage: handleImageSelection,
      orientation: state.orientation,
      print: handlePrint,
      changeOrientation
    }}>
      { props.children }
    </DataContext.Provider>
  )
}